import { useState } from 'react';
import { Button, Input } from '@eo/shared';

import { HoursStepper } from './HoursStepper';
import type { PlanAddExtraRowProps } from './types';

// One more row of the plan: why, and the hours each bucket gets this month.
export function PlanAddExtraRow({ clientName, onAdd }: PlanAddExtraRowProps) {
  const [notes, setNotes] = useState('');
  const [fixedHours, setFixedHours] = useState(0);
  const [variableHours, setVariableHours] = useState(0);
  const [saving, setSaving] = useState(false);

  const add = async () => {
    setSaving(true);
    try {
      await onAdd({ notes: notes.trim(), fixedHours, variableHours });
      setNotes('');
      setFixedHours(0);
      setVariableHours(0);
    } catch {
      // The failure was already announced; the row keeps its figures to retry.
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <Input
        aria-label="Why the extra hours"
        placeholder="Why… (e.g. board deck)"
        value={notes}
        maxLength={1000}
        onChange={(e) => setNotes(e.target.value)}
        className="h-8 text-sm"
      />
      <HoursStepper label="Extra fixed hours" value={fixedHours} min={0} onCommit={setFixedHours} />
      <HoursStepper
        label="Extra variable hours"
        value={variableHours}
        min={0}
        onCommit={setVariableHours}
      />
      <Button
        type="button"
        size="sm"
        variant="secondary"
        aria-label={`Add extra hours to ${clientName}`}
        disabled={(fixedHours === 0 && variableHours === 0) || saving}
        onClick={() => void add()}
      >
        Add
      </Button>
    </>
  );
}
